import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AgentButton = ({ onDone }) => {
  const { t } = useLanguage();
  const [generating, setGenerating] = useState(false);

  const start = async () => {
    setGenerating(true);
    try {
      await axios.post(
        `${API}/admin/agent/generate`,
        {},
        { headers: { Authorization: `Bearer ${localStorage.getItem("ghp-admin-token")}` } }
      );
      toast.success(t("admin.agentStarted"));
      let tries = 0;
      const iv = setInterval(async () => {
        tries++;
        await onDone();
        if (tries >= 18) {
          clearInterval(iv);
          setGenerating(false);
        }
      }, 10000);
    } catch {
      toast.error(t("forms.error"));
      setGenerating(false);
    }
  };

  return (
    <button
      onClick={start}
      disabled={generating}
      className="inline-flex items-center gap-2.5 bg-science px-6 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-graphite disabled:opacity-60"
      data-testid="admin-agent-generate-button"
    >
      <Sparkles className={`h-4 w-4 ${generating ? "animate-pulse" : ""}`} />
      {generating ? t("admin.agentGenerating") : t("admin.agentBtn")}
    </button>
  );
};

export default AgentButton;
